import { api } from '@/core/api/';

const apiUrl = 'api/location';

export default {
  getCaats() {
    return api.get(`${apiUrl}/caats`);
  },
  getAllCaats() {
    return api.get(`${apiUrl}/allcaats`);
  },
  getMunicipalities(academicYearId) {
    return api.get(`${apiUrl}/municipalities`, {
      params: {
        academicYearId,
      },
    });
  },
  getSchools(academicYearId, municipalityId) {
    return api.get(`${apiUrl}/schools`, {
      params: {
        academicYearId,
        municipalityId,
      },
    });
  },
};
